"use client";

import React from 'react';
import { motion } from 'framer-motion';
import AnimatedSection from '../AnimatedSection';
import { useTranslation } from 'react-i18next';
import Image from 'next/image';

const RegionSection = () => {
  const { t } = useTranslation();
  return (
    <section className="bg-brand-green py-20" id="region">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <AnimatedSection delay={0.2}>
            <div className="text-white">
              <motion.h2 
                className="text-4xl font-bold mb-8"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1 }}
              >
                {t("region.title")}
              </motion.h2>
              <motion.p 
                className="mb-6"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.4 }}
              >
                {t("region.description1")}
              </motion.p>
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.6 }}
              >
                {t("region.description2")}
              </motion.p>
            </div>
          </AnimatedSection>
          
          <AnimatedSection delay={0.4} className="relative">
            <motion.div 
              className="items-center justify-center"
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.8, delay: 1 }}
            >
              <Image 
                src="/images/region/mapa-desk-completo.png" 
                alt={t("region.map_alt")}
                width={800}
                height={600}
                className="md:block w-full h-auto"
              />
            </motion.div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
};

export default RegionSection;
